import {Typography} from "@mui/material";
import {capitalize} from "@mui/material/utils";
import React from "react";
import {useTranslation} from "react-i18next";
import {useT} from "../../../i18n";
import {AntwortTyp} from "../../../models/Antworttypen";


interface UnteraufgabeDetailCardProps {
     ueberschrift: string;
     titel?: string | null;
     prompt?: string | null;
     beschreibung?: string | null;
     antwort?: string | null;
     antwortTyp?: string | null;
     showDetails?: boolean;
     gewichtung?: number | null;
     rankingScore?: number | null;
}

export default function UnteraufgabeDetailCard({ueberschrift,titel,prompt,beschreibung, antwort, antwortTyp, showDetails, gewichtung, rankingScore}:UnteraufgabeDetailCardProps) {
    const {t:translationCommon} = useT();
    const {t:translation} = useTranslation("kontakte");
    const {t: translationSubtask} = useTranslation('unteraufgaben');
    const key = `answer-type-${antwortTyp?.toLowerCase() || 'unknown'}`;
    const translated = translationSubtask(key);
    return (<div>
        <Typography variant="subtitle1" fontWeight="bold">
            {ueberschrift}
        </Typography>
        <Typography variant="body2">
            <strong>{translation('title')}:</strong> {titel || 'N/A'}
        </Typography>
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            <strong>{translation('prompt')}:</strong> {prompt || 'N/A'}
        </Typography>
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            <strong>{translation('description')}:</strong> {beschreibung || 'N/A'}
        </Typography>

         <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
             <strong>{translation('answer')}:</strong> {antwortTyp === AntwortTyp.BOOLEAN
                                                               ? antwort ? translationCommon(`${AntwortTyp.BOOLEAN.toLowerCase()}-${antwort?.toLowerCase()}`) : 'N/A'
                                                               : antwort || 'N/A'}
        </Typography>

        {showDetails && <>
            <Typography variant="body2">
                <strong>{translation('answer-type')}:</strong> {(() => {
                return translated !== key ? capitalize(translated) : 'N/A';
            })()}
            </Typography>
            <Typography variant="body2">
                <strong>{translation('weighting')}:</strong> {gewichtung?.toFixed(2) || 'N/A'}
            </Typography>
            <Typography variant="body2">
                <strong>{translation('ranking-score')}:</strong> {rankingScore?.toFixed(2) || 'N/A'}
            </Typography>
        </>}

    </div>)
}